export function updateLocalPosition(oldValue, newValue, object) {
  var _a = object.parsedStyle,
      _b = _a.x,
      x = _b === void 0 ? 0 : _b,
      _c = _a.y,
      y = _c === void 0 ? 0 : _c,
      _d = _a.z,
      z = _d === void 0 ? 0 : _d; // update local position when x/y changed

  object.setLocalPosition(x, y, z);
}